<template>
  <div class="pagination-wrapper">
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
      :page-sizes="pageSizes" :page-size="pageSize" :layout="layout" :total="totalCount">
    </el-pagination>
  </div>
</template>

<script>
import { inject, toRaw } from 'vue';
import { cloneDeep } from 'lodash';

export default {
  emits: ['change'],
  props: {
    totalCount: {
      type: Number,
      default: 0,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 50, 100],
    },
    pageNum: {
      type: Number,
      default: 1,
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper',
    },
  },
  setup(props, { emit }) {
    const emitFn = inject('useQueryPage-pagination');
    const pipeObj = {};
    let pipeEvent = null;
    function emitPipe(event, part) {
      if (!pipeEvent) {
        Object.assign(pipeObj, {
          pageSize: props.pageSize,
          pageNum: props.pageNum,
          totalCount: props.totalCount,
        });
        pipeEvent = Promise.resolve().then(() => {
          emit(event, pipeObj);
          if (emitFn) {
            emitFn(cloneDeep(toRaw(pipeObj)), 'page');
          }
          pipeEvent = null;
        });
      }
      Object.assign(pipeObj, part);
    }
    function handleSizeChange(newPageSize) {
      emitPipe('change', {
        pageSize: newPageSize,
      });
    }
    function handleCurrentChange(newPageNum) {
      emitPipe('change', {
        pageNum: newPageNum,
      });
    }

    return {
      handleSizeChange,
      handleCurrentChange,
    };
  },
};
</script>

<style lang="scss" scoped>
.pagination-wrapper {
  padding: 15px 0 0 15px;
  text-align: center;
}
</style>
